import { fromJS, Record } from 'immutable';

export const ModalRecord = new Record({
  active: false,
  props: fromJS({}),
  type: ''
});

export default ModalRecord();
